"use strict";
angular.module("websiteNoRepeatModule", []).
controller("websiteNoRepeatCtrl", ["$scope", "items", "$modalInstance", "modalDialog", "methodName", "trsHttpService", function($scope, items, $modalInstance, modalDialog, methodName, trsHttpService) {
    initStatus();
    initData();
    /**
     * [initStatus description] 初始化状态
     * @return {[type]} [description]
     */
    function initStatus() {
        $scope.status = {};
        $scope.data = {
            items: items,
            selectedArray: []
        };
    }
    /**
     * [initData description] 初始化数据
     * @return {[type]} [description]
     */
    function initData() {}
    /**
     * [selectDoc description] 选中稿件
     * @param  {[type]} item [description] 稿件信息
     * @return {[type]}      [description]
     */
    $scope.selectDoc = function(item) {
        var index = $scope.data.selectedArray.indexOf(item);
        if (index >= 0) {
            $scope.data.selectedArray.splice(index, 1);
        } else {
            $scope.data.selectedArray.push(item);
        }
    };
    /**
     * [confirm description] 确认
     * @return {[type]} [description]
     */
    $scope.confirm = function() {
        var chnldocIDs = $scope.data.selectedArray.map(function(value, index) {
            return value.DOC.CHNLDOCID;
        }).join(",");
        var metadataIds = $scope.data.selectedArray.map(function(value, index) {
            return value.DOC.METADATAID;
        }).join(",");
        var params = {
            serviceid: "mlf_websiteoper",
            methodname: methodName,
            ObjectIds: chnldocIDs,
            ChnlDocIds: chnldocIDs,
            MetaDataIds: metadataIds,
            enforcement: "1"
        };
        $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "post").then(function(data) {
            modalDialog.alertType("签发成功", "", "success", false, function() {
                $modalInstance.close();
            });
        }, function(data) {
            $modalInstance.dismiss();
        });
    };
    /**
     * [cancel description] 取消
     * @return {[type]} [description]
     */
    $scope.cancel = function() {
        $modalInstance.close();
    };
}]);